(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-review"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const track = document.getElementById('carouselTrack');
    const cards = document.querySelectorAll('.testimonial-card');
    const paginationContainer = document.getElementById('paginationContainer');
    const progressBarFill = document.getElementById('progressBarFill');
    
    let currentIndex = 0;
    const cardWidth = 300 + 20;
    let cardsPerView = 4;
    let totalPages = Math.ceil(cards.length / cardsPerView);

    function initPagination() {
      paginationContainer.innerHTML = '';
      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('div');
        dot.className = `pagination-dot ${i === 0 ? 'active' : ''}`;
        dot.onclick = () => goToPage(i);
        paginationContainer.appendChild(dot);
      }
      updatePaginationDots();
    }

    function updatePaginationDots() {
      const dots = document.querySelectorAll('.pagination-dot');
      const activePage = Math.floor(currentIndex / cardsPerView);
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === activePage);
      });
      updateProgressBar();
    }

    function updateProgressBar() {
      const activePage = Math.floor(currentIndex / cardsPerView);
      const progressPercentage = ((activePage + 1) / totalPages) * 100;
      progressBarFill.style.width = progressPercentage + '%';
    }

    window.scrollCarousel = function(direction) {
      const maxIndex = cards.length - cardsPerView;
      currentIndex += direction * cardsPerView;
      
      if (currentIndex < 0) {
        currentIndex = maxIndex;
      } else if (currentIndex > maxIndex) {
        currentIndex = 0;
      }
      
      updateCarousel();
    };

    function goToPage(pageIndex) {
      currentIndex = pageIndex * cardsPerView;
      updateCarousel();
    }

    function updateCarousel() {
      const offset = -currentIndex * cardWidth;
      track.style.transform = `translateX(${offset}px)`;
      updatePaginationDots();
    }

    function handleResize() {
      const width = window.innerWidth;
      let newCardsPerView = 4;
      
      if (width < 1200) {
        newCardsPerView = 3;
      }
      if (width < 768) {
        newCardsPerView = 2;
      }
      if (width < 480) {
        newCardsPerView = 1;
      }
      
      if (newCardsPerView !== cardsPerView) {
        cardsPerView = newCardsPerView;
        totalPages = Math.ceil(cards.length / cardsPerView);
        currentIndex = 0;
        initPagination();
        updateCarousel();
      }
    }

    initPagination();
    handleResize();
    window.addEventListener('resize', handleResize);
  })();

  } catch(e) { console.error(e); }
})();
})();
